import React from 'react';
import PropTypes from 'prop-types';
import {
  ACCREDITATION_21A_INTRO_URL,
  OGC_ACCREDITATION_URL,
} from '../../utilities/constants';
import {
  useHasSubmitted21aForm,
  useShowForm21aLink,
} from '../../utilities/accreditation21a';
import { InProgressAlert, SubmittedAlert } from './Accreditation21aAlerts';

/**
 * "Apply for accreditation" section shown to non-authorized users on the
 * dashboard. Renders a status alert (in-progress or submitted) when applicable,
 * otherwise the baseline "start your application" link-action.
 */
const ApplyForAccreditation = ({ hasInProgressForm = false }) => {
  const hasSubmittedForm = useHasSubmitted21aForm();
  const showForm21aLink = useShowForm21aLink();

  return (
    <>
      <h2 className="dashboard__header">Apply for accreditation</h2>
      {hasInProgressForm && (
        <InProgressAlert href={ACCREDITATION_21A_INTRO_URL} />
      )}
      {!hasInProgressForm && hasSubmittedForm && (
        <SubmittedAlert href={ACCREDITATION_21A_INTRO_URL} />
      )}
      <p>
        You can use the portal to apply for accreditation as a claims agent or
        attorney with the Office of General Counsel (OGC). We’ll save your
        progress as you go, and you can come back anytime to finish your
        application.
      </p>
      <p>
        <va-link
          href={OGC_ACCREDITATION_URL}
          text="Learn about OGC Accreditation, Discipline, & Fees Program"
        />
      </p>
      {showForm21aLink && (
        <p>
          <va-link-action
            type="secondary"
            href={ACCREDITATION_21A_INTRO_URL}
            text="Start or continue your application for accreditation (VA Form 21a)"
          />
        </p>
      )}
    </>
  );
};

ApplyForAccreditation.propTypes = {
  hasInProgressForm: PropTypes.bool,
};

export default ApplyForAccreditation;
